/* Keep the existing product form as the single purchase source of truth. */
(() => {
  const mark = () => {
    const root = document.querySelector('[data-bh-sova-purchase]');
    if (!root) return;
    const section = root.closest('.shopify-section');
    section?.classList.add('bh-sova-main');
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mark, {once:true});
  else mark();
})();
